module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"An error occurred!":"Es ist ein Fehler aufgetreten!","Shipping method could not be saved.":"Versandmethode konnte nicht gespeichert werden."}}')
  delete Component.options._Ctor
}
